export interface HashtagFormValues {
	name: string;
	description: string;
	color: string;
	isPrivate: boolean;
	isFavourite: boolean;
	excludeFromMainFeed: boolean;
	image: File | null;
}

export function formValuesToHashtag(
	data: HashtagFormValues
): Partial<AdminHashtag> {
	return {
		name: data.name,
		description: data.description || null,
		color: data.color,
		isPrivate: data.isPrivate,
		isFavourite: data.isFavourite,
		excludeFromMainFeed: data.excludeFromMainFeed
	};
}
